import styled from '@emotion/styled';

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  font-size: 16px; /* Ensuring uniform font size */
  font-weight: bold; /* Matching prefix and input text */
  color: gray; /* Same color for consistency */
`;

export const Prefix = styled.span`
  color: gray;
  font-weight: bold;
`;

export const StyledInput = styled.input`
  border: ${(props) => (props.isValid ? 'none' : '1px solid red')};
  outline: none;
  margin-left: 8px;
  font-size: inherit; /* Matches parent (InputContainer) */
  font-weight: inherit; /* Ensures consistency */
  color: inherit; /* Same text color as prefix */
  flex: 1;
`;
